import React from 'react';
import { Phone, Mail } from 'react-feather';
import { FaSkype, FaTelegramPlane } from 'react-icons/fa';

const contactModal = (props) => (
    <div className="ContactModal">
        <div className="modal-body text-center">
            <h5 className="mb-3 pb-3 border-bottom font-weight-bold">{props.affiliate.affiliate_manager.name}</h5>
            <p><Phone size={20} style={{ paddingRight: "5px" }} />{props.affiliate.affiliate_manager.phone}</p>
            <p><a href={`mailto:${props.affiliate.affiliate_manager.email}`}><Mail size={20} style={{ paddingRight: "5px" }} />{props.affiliate.affiliate_manager.email}</a></p>
            <p><a href={`https://t.me/${props.affiliate.affiliate_manager.im_handle}`}><FaTelegramPlane size={20} style={{ paddingRight: "5px" }} />{props.affiliate.affiliate_manager.im_handle}</a></p>
            <div>
                <img className="w-100 rounded" src={`${props.affiliate.affiliate_manager.telegram_qr_code}`} alt="Telegram Code" />
            </div>
        </div>
    </div>
);


export default contactModal;